import React from 'react';

type ObjectType = {
  getPositionStyle?: Function;
  popoverTriggerClass?: string;
};

export default React.createContext<ObjectType>({});
